import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';
import FormatterUtils from '../../../utils/formatter.utils';
import Toast from '../../shared/Toast/Toast';

export const EnterAmountPageViewProvider = (
  t,
  params,
  getCurrency,
  service,
) => {
  if (service === EnterAmountType.MICROLOAN) {
    return {
      toast: {
        message: t('Minimum transfer is {minimum_transfer}', {
          '{minimum_transfer}': params?.min
            ? FormatterUtils.currency(
                params?.min,
                getCurrency(params?.currency),
              )
            : '',
        }),
        type: Toast.Type.ERROR,
      },
    };
  }

  if (service === EnterAmountType.MICROLOAN_PAYMENT) {
    return {
      isAmountInputDisabled: true,
      toast: {
        message: t('Amount is not editable'),
        type: Toast.Type.ERROR,
      },
    };
  }

  return {};
};
